import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { registrationsAPI } from '@/services/registrationsApi';
import { racesAPI } from '@/services/racesApi';
import { raceTypesAPI } from '@/services/raceTypesApi';
import RegistrationSuccessPageView from './registrationsuccesspage.view';

const RegistrationSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const registrationId = searchParams.get('id') || searchParams.get('Details2');

  const [registration, setRegistration] = useState<any>(null);
  const [raceName, setRaceName] = useState('');
  const [raceTypeName, setRaceTypeName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (registrationId) {
      confirmAndFetch();
    } else {
      setLoading(false);
    }
  }, [registrationId]);

  const confirmAndFetch = async () => {
    try {
      setLoading(true);

      let reg;
      try {
        reg = await registrationsAPI.publicConfirmRegistration(registrationId, 'Paid');
      } catch (confirmErr) {
        reg = await registrationsAPI.getRegistrationById(registrationId);
      }
      setRegistration(reg);

      try {
        const race = await racesAPI.getRaceById(reg.raceId);
        setRaceName(race.name);
        const types = await raceTypesAPI.getRaceTypes(reg.raceId);
        const raceType = types.find((t: any) => t.id === reg.raceTypeId);
        if (raceType) setRaceTypeName(raceType.name);
      } catch {
        // Non-critical
      }
    } catch (err) {
      setError('Не можевме да ја потврдиме регистрацијата. Обидете се повторно.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <RegistrationSuccessPageView
      loading={loading}
      error={error}
      registration={registration}
      raceName={raceName}
      raceTypeName={raceTypeName}
      onNavigateHome={() => navigate('/')}
    />
  );
};

export default RegistrationSuccessPage;
